import { Interval } from 'luxon';

export interface ICalculateEpisodePositionsOptions {
  /**
   * Range of the day that the episode corresponds to.
   */
  day: Interval;
  episode: {
    /**
     * Start and end date range of the episode.
     */
    range: Interval;
  };
}

export interface ICalculatedEpisodePosition {
  /**
   * The normalized width of the episode, according to the total day range
   */
  width: number;
  /**
   * Distance between the start of the day, and the episode start date.
   *
   * This is supposed to be used to calculate the left position of the episode.
   *
   * Which is basically how much we should shift the episode from the start of the row, so
   * the position of the episode element inside the row element, matches the position
   * of the episode inside the day.
   */
  distance: number;
  /**
   * Interval of episode that this position interface corresponds to.
   */
  range: Interval;
}

/**
 * Calculate the size and distance of an episode based on the information about the range of the day.
 * @param options Options with information about the episode
 * @returns The normalized calculations of the size and shift of the episode according to the day.
 */
export default function calculateEpisodePosition(
  options: ICalculateEpisodePositionsOptions
): ICalculatedEpisodePosition {
  const { episode: ep, day } = options;
  const daysMillisecondsCount = day.count('milliseconds');
  const distance = ep.range.start.diff(day.start, 'milliseconds').milliseconds;
  return {
    range: ep.range,
    width: ep.range.count('milliseconds') / daysMillisecondsCount,
    distance: distance / daysMillisecondsCount
  };
}
